<template>
  <div class="survey-container">
    <!--  :deviceNum="'only'" -->
    <search
      :formModel="formModel"
      :rules="rules"
      :formButton="formButton"
      :deviceModelBusiType="1"
      :upLeveName="'survey'"
    ></search>
    <v-main class="survey-content" :loading="loading">
      <el-card :header="'一、概述' | translateTo(i18nPath)" class="v-block">
        <p class="overview">
          <span>{{ overview }}</span>
          <span v-if="!overview">{{ '暂无数据' | translateTo(i18nPath) }}</span>
        </p>
      </el-card>
      <el-card
        :header="`二、设备本底情况${dateRangeText}` | translateTo(i18nPath)"
        class="v-block mt-15"
      >
        <span class="hint" v-if="!data || !data.length">
          {{ '暂无数据' | translateTo(i18nPath) }}
        </span>
        <template v-else>
          <part
            type="line"
            option="chart,table"
            v-for="(e, i) in data"
            :sn="e.sn"
            :key="e.sn"
            :names="e.names"
            :chart-opts="e.opts"
            :i18n-path="i18nPath"
            :table-data="e.tableData"
            :table-cfg="getTableCfg()"
            :header="`${i + 1}、${e.sn}`"
          ></part>
        </template>
      </el-card>
    </v-main>
  </div>
</template>

<script>
import { getBgInvestigation } from '@/api/dataAnalysis';

import Search from '@/components/mTable/search';
import VMain from './components/v-main';
import Part from './components/part.vue';

import { search } from './utils/survey-mixin';
import { convertData, validParam, imgsKeyParser } from './utils/index';
import { canvasToImg, downFile, arrify } from '@/utils/utils';

export default {
  mixins: [search],
  components: {
    VMain,
    Part,
    Search
  },
  data() {
    return {
      i18nPath: 'dataAnalysis',
      overview: ``,
      data: null,
      loading: true
    };
  },
  methods: {
    initSearchHooks() {
      this.searchHooks.set('resetData', this.resetData);
      this.searchHooks.set('getData', this.getData);
      this.searchHooks.set('changeDateRangeText', this.changeDateRangeText);
    },
    getData() {
      const { sn, rangeDateVal, deviceModel, taskId, officeId } = this.formModel;
      getBgInvestigation(
        validParam({
          sn: arrify(sn || null),
          beginTime: rangeDateVal[0],
          endTime: rangeDateVal[1],
          officeId: officeId,
          taskId: taskId,
          deviceTypeCode: deviceModel
        })
      )
        .then(res => {
          if (res && res.data) {
            const { data, description } = res.data;
            this.overview = description;
            this.$set(this, 'data', convertData(data));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetData() {
      this.loading = true;
      this.$set(this, 'data', null);
    },
    exportData() {
      this.formButton[1].loading = true;
      const { sn, rangeDateVal, deviceModel, taskId, officeId } = this.formModel;
      canvasToImg().then(imgs => {
        downFile({
          url: '/stat/exportBgInvestigation',
          method: 'post',
          data: validParam({
            sn: arrify(sn),
            beginTime: rangeDateVal[0],
            endTime: rangeDateVal[1],
            officeId: officeId,
            taskId: taskId,
            deviceTypeCode: deviceModel,
            pics: imgsKeyParser(imgs)
          })
        }).finally(() => {
          this.formButton[1].loading = false;
        });
      });
    },
    getTableCfg() {
      return {
        tableColumn: [
          { prop: 'name', label: '监测项' },
          { prop: 'avg', label: '平均值' },
          { prop: 'max', label: '最大值' },
          { prop: 'min', label: '最小值' }
        ]
      };
    }
  }
};
</script>

<style lang="scss">
$p: 'survey';
.#{$p}-container {
  height: 100%;
  .#{$p}-content {
    margin-top: 30px;
    background: $bg-color;
    height: calc(100% - 80px);
    .overview {
      white-space: pre-line;
    }
  }
}
</style>
